<fa-icon [ngbTooltip]="'This data is not updated in real-time.'" icon="info-circle"> </fa-icon>
